import { FilterExpression } from '@infuse/api/common';

export enum FilterConfigurationType {
  QUERY,
  RADIO,
  SELECT,
  MULTI_SELECT,
  SEARCH_SELECT,
  NUMERICAL,
  LT,
  LTE,
  GT,
  GTE,
  STRING_GT,
  STRING_LT,
  STRING_GTE,
  STRING_LTE,
  CUSTOM
}

export enum ComparisonType {
  EQ,
  NE,
  LT,
  LTE,
  GT,
  GTE
}

export interface FilterOption {
  name: string;
  label: () => string;

  toUmbrellaExpression(value?: string): FilterExpression;
  toNegatedUmbrellaExpression?(value?: string): FilterExpression; // if not defined, expression will be negated using 'not'
}

export interface FilterConfiguration {
  name: string;
  label: () => string;
  type: FilterConfigurationType;
  component?: any;
  componentProps?: Record<string, unknown>;
  options: FilterOption[];
  excludeFromUmbrella?: boolean;
  singleton?: boolean;
}

export interface Filter {
  config: FilterConfiguration;
  selectedOption: FilterOption;
  negated: boolean;
  searchQuery?: string; // used for query (search) filters
  displayValue?: string;
}
